import React, { useState, useContext, useEffect, useRef } from 'react'
import './Home.css'
import { Link, useHistory } from 'react-router-dom'
import AuthContext from '../../product/context/auth/authContext'
import CustomCommonContext from '../../custom/context/common/commonContext'
import ProductCommonContext from '../../product/context/common/commonContext'
import AuctionContext from '../../product/context/auction/auctionContext'
import AlertContext from '../../product/context/alert/alertContext'
import ProductContext from '../../product/context/product/productContext'
import PrimaryButton from '../../product/components/atoms/PrimaryButton'
import { makeStyles } from '@material-ui/core/styles'
import openSocket from 'socket.io-client'
import Slider from 'react-slick'
import { handleRedirectInternal, sortCategoryAlphabetical } from '../../product/common/components'
import NoRecordsFound from '../../custom/components/atoms/NoRecordsFound'
import AuctionCard from '../../custom/components/molecules/ProductCard/AuctionCard'
import { messageHandler } from '../../product/common/socketHandler'
import PropTypes from 'prop-types'
import AppBar from '@material-ui/core/AppBar'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import Box from '@material-ui/core/Box'
import moment from 'moment'
import HomePageCarousel from '../../custom/components/molecules/HomePageCarousel'
import useIsMobile from '../../custom/common/useMobile'
import { Accordion, AccordionSummary, AccordionDetails, Button } from '@material-ui/core'
import { ExpandMore } from '@material-ui/icons'
import AvatarImage from '../../product/components/atoms/AvatarImage'

function TabPanel(props) {
    const { children, value, index, ...other } = props

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box>{children}</Box>}
        </div>
    )
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    }
}

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    backButton: {
        marginRight: theme.spacing(1),
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    fullList: {
        width: 'auto',
    },
}))

function Home() {
    const history = useHistory()
    const authContext = useContext(AuthContext)
    const auctionContext = useContext(AuctionContext)
    const alertContext = useContext(AlertContext)
    const customCommonContext = useContext(CustomCommonContext)
    const productCommonContext = useContext(ProductCommonContext)

    const productContext = useContext(ProductContext)
    const { user, isAuthenticated, saveSearch, callEnd } = authContext
    const { search_allauctions, getAllAuctionProducts } = auctionContext
    const { setAlert } = alertContext

    const { search_allproducts, getAllSearchProducts, responseStatus } = productContext
    const { categoryTypes, wineCountryOptions, allConfigurationVariables } = customCommonContext

    const { getStaticPage, static_page, setSearchValue, searchValue, clearSearchValue } =
        productCommonContext
    const [value, setValue] = useState(0)
    const [topvalue, setValueNew] = useState(0)

    let [viewStaticTabOne, setviewStaticTabOne] = useState(null)
    let [viewStaticTabTwo, setviewStaticTabTwo] = useState(null)
    let [viewStaticTabThree, setviewStaticTabThree] = useState(null)
    let [viewStaticTabFour, setviewStaticTabFour] = useState(null)
    let [viewStaticTabFive, setviewStaticTabFive] = useState(null)

    let [viewProduct, setViewProduct] = useState([])
    let [auctions, setAuctions] = useState([])

    const [previousSlideIndex, setPreviousSlideIndex] = useState(0)
    const [currentSlideIndex, setCurrentSlideIndex] = useState(0)
    const [nextSlideIndex, setNextSlideIndex] = useState(0)
    const [otherCountries, setOtherCountries] = useState('')

    const [isLoading, setIsLoading] = useState(false)

    //PRODUCT SLIDER
    const classes = useStyles()

    const mobile = useIsMobile()

    const [state, setState] = useState({
        right: false,
        bottom: false,
        data: {},
    })

    const [searchAuction, setSearchAuction] = useState({
        limit: global.initialPageLimit,
        page: 1,
        orderby: 'p.id, ASC',
    })

    useEffect(() => {
        //Set date 2 days back from current date
        let date = new Date(Date.now() - 3 * 24 * 60 * 60 * 1000)
        let lastTwoDaysDate = moment(date).format('YYYY-MM-DD HH:mm:ss')

        let searchObjRecentProduct = {
            limit: global.initialPageLimit,
            page: 1,
            orderby: 'p.id, ASC',
            // orderby: 'p.id, desc',
            order: '',
        }
        getAllSearchProducts(searchObjRecentProduct)
        getAllAuctionProducts(searchAuction, 'homePage')
        setIsLoading(false)
    }, [callEnd])

    useEffect(() => {
        setIsLoading(true)
    }, [])

    const onHandlePageAuction = (event, value) => {
        setSearchAuction({ ...searchAuction, page: value })
    }

    useEffect(() => {
        setViewProduct(search_allproducts.records.length ? search_allproducts.records : [])
        setIsLoading(false)
    }, [search_allproducts])

    useEffect(() => {
        if (search_allauctions.from === 'homePage') {
            setAuctions(search_allauctions.records.length ? search_allauctions.records : [])
        }
    }, [search_allauctions])

    useEffect(() => {
        setViewProduct([])
        return () => {
            setViewProduct([])
        }
    }, [])

    const viewProductRef = useRef(viewProduct)
    const userRef = useRef(user)
    useEffect(() => {
        viewProductRef.current = viewProduct
        userRef.current = user
    })

    const handler = (message, type) => {
        messageHandler(
            message,
            viewProductRef.current,
            userRef.current,
            setAlert,
            setViewProduct,
            type,
        )
    }
    useEffect(() => {
        const socket = openSocket(`${process.env.REACT_APP_DOMAIN}/`, { transports: ['websocket'] })
        socket.on('realclosedupdates', (data) => {
            handler(data, 'realclosedupdates')
        })
        socket.on('bidAddtime', (data) => {
            handler(data, 'bidAddtime')
        })
        return () => {
            socket.off('realclosedupdates', (data) => {
                handler(data, 'realclosedupdates')
            })
            socket.off('bidAddtime', (data) => {
                handler(data, 'bidAddtime')
            })
            socket.disconnect()
        }
    }, [])

    useEffect(() => {
        if (state.right) {
            const index = viewProduct.findIndex((s) => s.id == parseInt(state.data.id, 10))
            if (index !== -1) {
                setState({ ...state, data: viewProduct[index] })
            }
        }
    }, [viewProduct])

    const toggleDrawer = (anchor, open, data) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return
        }
        if (open) {
            setState({ ...state, [anchor]: open, data: data })
        } else {
            setState({ ...state, [anchor]: open, data: {} })
        }
    }

    // SEARCH
    const getSearchBarObjet = (value) => {
        return {
            filters: {
                searchbar: {
                    value: value,
                },
            },
        }
    }

    const handleChangeNew = (event, newValue) => {
        setValueNew(newValue)
    }

    const sellYourWine = [
        {
            img: '/assets/svg/reliable.svg',
            title: 'Free Professional Appraisal',
            desc: 'Simply send us a list of your wines and TCWC will use nearly 50 years of experience to provide an accurate appraisal and optimal auction strategy to suit your collection',
        },
        {
            img: '/assets/svg/winemarket.svg',
            title: 'Access to Markets',
            desc: 'TCWC has a dedicated team that will market your wines to passionate collectors and trade members actively seeking top wines.',
        },
        {
            img: '/assets/svg/access.svg',
            title: '24/7 Visibility',
            desc: 'Online access to your collection once inventoried and entered into our system',
        },
        {
            img: '/assets/svg/shipping.svg',
            title: 'Logistics',
            desc: 'Transportation and logistics fully arranged by TCWC',
        },
    ]

    const atnsettings = {
        dots: false,
        infinite: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: true,
        speed: 1000,
        autoplaySpeed: 3000,
        cssEase: 'linear',
        responsive: [
            {
                breakpoint: 1240,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 540,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    }

    const imgStyling = {
        cursor: 'pointer',
    }

    const chateauImage1Name = 'Chateau Leoville Barton'
    const chateauImage2Name = 'Chateau Leoville Las Cases'
    const chateauImage3Name = 'Chateau Leoville Poyferre'

    const getCountryObject = (value) => {
        let custitem_gvo_country = {
            type: 'array',
            field: 'cp.custitem_gvo_country',
            value,
        }
        // Assign value to searchbar object

        return {
            limit: global.initialPageLimit,
            page: 1,
            orderby: 'p.id, desc',
            order: '',
            filters: {
                custitem_gvo_country,
            },
        }
    }

    const handleCountryButtonClick = (id) => {
        if (id !== '') {
            if (location.pathname != '/search') {
                let queryObject = {}
                queryObject.country = id
                const params = new URLSearchParams(queryObject)
                handleRedirectInternal(history, `search?${params.toString()}`)
            } else {
                setSearchValue(getCountryObject(id))
            }
        }
    }
    useEffect(() => {
        getStaticPage({ id: 'mid_page_first_tab' }, 'mid_page_first_tab')
        getStaticPage({ id: 'mid_page_second_tab' }, 'mid_page_second_tab')
        getStaticPage({ id: 'mid_page_third_tab' }, 'mid_page_third_tab')
        getStaticPage({ id: 'mid_page_fourth_tab' }, 'mid_page_fourth_tab')
        getStaticPage({ id: 'mid_page_fifth_tab' }, 'mid_page_fifth_tab')
    }, [])

    useEffect(() => {
        if (static_page.from === 'mid_page_first_tab') {
            setviewStaticTabOne(static_page.record ? static_page.record.content : null)
        }
        if (static_page.from === 'mid_page_second_tab') {
            setviewStaticTabTwo(static_page.record ? static_page.record.content : null)
        }
        if (static_page.from === 'mid_page_third_tab') {
            setviewStaticTabThree(static_page.record ? static_page.record.content : null)
        }
        if (static_page.from === 'mid_page_fourth_tab') {
            setviewStaticTabFour(static_page.record ? static_page.record.content : null)
        }
        if (static_page.from === 'mid_page_fifth_tab') {
            setviewStaticTabFive(static_page.record ? static_page.record.content : null)
        }
    }, [static_page])
    let homePageArray = []
    if (allConfigurationVariables.mid_page_first_tab) {
        homePageArray.push({
            head: allConfigurationVariables.mid_page_first_tab,
            content: (
                <section className="winClubInfo">
                    {/* <h2>{allConfigurationVariables.mid_page_first_tab}</h2> */}
                    <div className="d-flex align-items-center justify-content-between">
                        <div
                            dangerouslySetInnerHTML={{
                                __html: viewStaticTabOne,
                            }}
                        ></div>
                    </div>
                </section>
            ),
        })
    }

    if (allConfigurationVariables.mid_page_second_tab) {
        homePageArray.push({
            head: allConfigurationVariables.mid_page_second_tab,
            content: (
                <section className="winClubInfo">
                    {/* <h2>{allConfigurationVariables.mid_page_second_tab}</h2> */}
                    <div className="d-flex align-items-center justify-content-between">
                        <div
                            dangerouslySetInnerHTML={{
                                __html: viewStaticTabTwo,
                            }}
                        ></div>
                    </div>
                </section>
            ),
        })
    }

    if (allConfigurationVariables.mid_page_third_tab) {
        homePageArray.push({
            head: allConfigurationVariables.mid_page_third_tab,
            content: (
                <section className="winClubInfo">
                    {/* <h2>{allConfigurationVariables.mid_page_third_tab}</h2> */}
                    <div className="d-flex align-items-center justify-content-between">
                        <div
                            dangerouslySetInnerHTML={{
                                __html: viewStaticTabThree,
                            }}
                        ></div>
                    </div>
                </section>
            ),
        })
    }

    if (allConfigurationVariables.mid_page_fourth_tab) {
        homePageArray.push({
            head: allConfigurationVariables.mid_page_fourth_tab,
            content: (
                <section className="winClubInfo">
                    {/* <h2>{allConfigurationVariables.mid_page_fourth_tab}</h2> */}
                    <div className="d-flex align-items-center justify-content-between">
                        <div
                            dangerouslySetInnerHTML={{
                                __html: viewStaticTabFour,
                            }}
                        ></div>
                    </div>
                </section>
            ),
        })
    }
    if (allConfigurationVariables.mid_page_fifth_tab) {
        homePageArray.push({
            head: allConfigurationVariables.mid_page_fifth_tab,
            content: (
                <section className="winClubInfo">
                    {/* <h2>{allConfigurationVariables.mid_page_fifth_tab}</h2> */}
                    <div className="d-flex align-items-center justify-content-between">
                        <div
                            dangerouslySetInnerHTML={{
                                __html: viewStaticTabFive,
                            }}
                        ></div>
                    </div>
                </section>
            ),
        })
    }

    // homePageArray.push(
    //     {
    //         head: 'Sell Your Wine',
    //         content: (
    //             <div className="grdCntnr">
    //                 {sellYourWine.map((data, index) => (
    //                     <div
    //                         onClick={() => handleRedirectInternal(history, 'selling_wine')}
    //                         key={index}
    //                         className="slYrWnCard d-flex align-items-start cursorDecoy"
    //                     >
    //                         <div className="imgCotnr" key={index}>
    //                             <img src={data.img} />
    //                         </div>
    //                         <div className="txtIfoCntr pl-3 pr-4">
    //                             <h3>{data.title}</h3>
    //                             <p>{data.desc}</p>
    //                         </div>
    //                     </div>
    //                 ))}
    //             </div>
    //         ),
    //     },
    //     // {
    //     //     head: 'Wine Club',
    //     //     content: (
    //     //         <section className="winClubInfo">
    //     //             <h2>Wine Club</h2>
    //     //             <div className="d-flex align-items-center justify-content-between">
    //     //                 <p>
    //     //                     Choose the club that best suits you and receive access to
    //     //                     member-exclusive wines, events, and promotions!
    //     //                 </p>
    //     //                 <PrimaryButton
    //     //                     onClick={() => handleRedirectInternal(history, 'contact')}
    //     //                     label={
    //     //                         <span>
    //     //                             <img
    //     //                                 src="/assets/svg/wineglass.svg"
    //     //                                 alt="wine glass"
    //     //                                 className="mr-3"
    //     //                             />
    //     //                             Join Our Club{' '}
    //     //                         </span>
    //     //                     }
    //     //                 />
    //     //             </div>
    //     //         </section>
    //     //     ),
    //     // },
    // )

    // useEffect(() => {
    //     if (search_allproducts) {
    //         if (search_allproducts.sorts) {
    //             if (search_allproducts.sorts.sortdata_gvo_country) {
    //                 let otherCountriesFilters =
    //                     search_allproducts.sorts.sortdata_gvo_country.filter(
    //                         (inner) => inner !== '230' && inner !== '110' && inner !== '75',
    //                     )
    //                 console.log('otherCountriesFilters 2222', otherCountriesFilters)
    //                 setOtherCountries(otherCountriesFilters)
    //             }
    //         }
    //     }
    // }, [search_allproducts])

    useEffect(() => {
        if (categoryTypes) {
            if (categoryTypes.length) {
                let otherCountriesFilters = categoryTypes
                    .filter((type) => type.level === 1 && type.level_id === 4)
                    .map(function (item) {
                        return item.value
                    })
                setOtherCountries(otherCountriesFilters)
            }
        }
    }, [categoryTypes])

    const [expanded, setExpanded] = useState(false)

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false)
    }

    return (
        <div className="home">
            <section className="heroBanner">
                <HomePageCarousel />
            </section>
            <section className="homeAuctions wineTopTabs mt-3 mt-sm-5 ck-content">
                <div className="customContainer mobile-accordian">
                    {allConfigurationVariables.mid_page_first_tab ? (
                        <Accordion
                            expanded={expanded === 'panel1'}
                            onChange={handleChange('panel1')}
                        >
                            <AccordionSummary
                                expandIcon={<ExpandMore />}
                                aria-controls="panel1bh-content"
                                id="panel1bh-header"
                            >
                                <h4>{allConfigurationVariables.mid_page_first_tab}</h4>
                            </AccordionSummary>

                            <AccordionDetails className="justify-content-center flex-wrap">
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: viewStaticTabOne,
                                    }}
                                ></div>
                            </AccordionDetails>
                        </Accordion>
                    ) : null}
                    {allConfigurationVariables.mid_page_second_tab ? (
                        <Accordion
                            expanded={expanded === 'panel2'}
                            onChange={handleChange('panel2')}
                        >
                            <AccordionSummary
                                expandIcon={<ExpandMore />}
                                aria-controls="panel1bh-content"
                                id="panel1bh-header"
                            >
                                <h4>{allConfigurationVariables.mid_page_second_tab}</h4>
                            </AccordionSummary>

                            <AccordionDetails className="justify-content-center flex-wrap">
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: viewStaticTabTwo,
                                    }}
                                ></div>
                            </AccordionDetails>
                        </Accordion>
                    ) : null}
                    {allConfigurationVariables.mid_page_third_tab ? (
                        <Accordion
                            expanded={expanded === 'panel3'}
                            onChange={handleChange('panel3')}
                        >
                            <AccordionSummary
                                expandIcon={<ExpandMore />}
                                aria-controls="panel1bh-content"
                                id="panel1bh-header"
                            >
                                <h4>{allConfigurationVariables.mid_page_third_tab}</h4>
                            </AccordionSummary>

                            <AccordionDetails className="justify-content-center flex-wrap">
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: viewStaticTabThree,
                                    }}
                                ></div>
                            </AccordionDetails>
                        </Accordion>
                    ) : null}
                    {allConfigurationVariables.mid_page_fourth_tab ? (
                        <Accordion
                            expanded={expanded === 'panel4'}
                            onChange={handleChange('panel4')}
                        >
                            <AccordionSummary
                                expandIcon={<ExpandMore />}
                                aria-controls="panel1bh-content"
                                id="panel1bh-header"
                            >
                                <h4>{allConfigurationVariables.mid_page_fourth_tab}</h4>
                            </AccordionSummary>

                            <AccordionDetails className="justify-content-center flex-wrap">
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: viewStaticTabFour,
                                    }}
                                ></div>
                            </AccordionDetails>
                        </Accordion>
                    ) : null}
                    {allConfigurationVariables.mid_page_fifth_tab ? (
                        <Accordion
                            expanded={expanded === 'panel5'}
                            onChange={handleChange('panel5')}
                        >
                            {/* <AccordionSummary
                            expandIcon={<ExpandMore />}
                            aria-controls="panel1bh-content"
                            id="panel1bh-header"
                        >
                            <h4>Sell Your Wine</h4>
                        </AccordionSummary> */}
                            <AccordionSummary
                                expandIcon={<ExpandMore />}
                                aria-controls="panel1bh-content"
                                id="panel1bh-header"
                            >
                                <h4>{allConfigurationVariables.mid_page_fifth_tab}</h4>
                            </AccordionSummary>

                            <AccordionDetails className="justify-content-center flex-wrap">
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: viewStaticTabFive,
                                    }}
                                ></div>
                            </AccordionDetails>

                            {/* <AccordionDetails className="syw-wrap flex-wrap text-left">
                            {sellYourWine.map((data, index) => (
                                <div
                                    onClick={() => handleRedirectInternal(history, 'selling_wine')}
                                    key={index}
                                    className="slYrWnCard d-flex align-items-start cursorDecoy"
                                >
                                    <div className="imgCotnr" key={index}>
                                        <img src={data.img} />
                                    </div>
                                    <div className="txtIfoCntr pl-3 pr-4">
                                        <h3>{data.title}</h3>
                                        <p>{data.desc}</p>
                                    </div>
                                </div>
                            ))}
                        </AccordionDetails> */}
                        </Accordion>
                    ) : null}
                    {/* <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMore />}
                            aria-controls="panel1bh-content"
                            id="panel1bh-header"
                        >
                            <h4>Wine Club</h4>
                        </AccordionSummary>

                        <AccordionDetails className="justify-content-center flex-wrap">
                            <div className="wineClubInfo">
                                <h2>Wine Club</h2>
                                <div className="d-flex justify-content-between align-items-center">
                                    <p>
                                        Choose the club that best suits you and receive access to
                                        member-exclusive wines, events, and promotions!
                                    </p>
                                    <PrimaryButton
                                        onClick={() => handleRedirectInternal(history, 'contact')}
                                        btnSize="large"
                                        label={
                                            <span>
                                                <img
                                                    src="/assets/svg/wineglass.svg"
                                                    alt="wine glass"
                                                    className="mr-3"
                                                />
                                                Join Our Club{' '}
                                            </span>
                                        }
                                    />
                                </div>
                            </div>
                        </AccordionDetails>
                    </Accordion> */}
                </div>
            </section>
            <section
                className="homeAuctions liveUpcoming mt-3 mt-sm-5"
                style={{
                    backgroundImage: `url(${
                        allConfigurationVariables.home_auction_image
                            ? `${global.site_url}/uploads/config/${allConfigurationVariables.home_auction_image}`
                            : `/assets/images/auctionsBanner.jpg`
                    })`,
                }}
            >
                <div className="customContainer d-flex align-items-center h-100">
                    <div className="liveUpcomingInner">
                        <h2 className="homeTitle">Live & Upcoming Auctions</h2>
                        <PrimaryButton
                            id="viewallauctons_button"
                            label="View all auctions"
                            onClick={() => handleRedirectInternal(history, 'auction')}
                        />
                    </div>
                    {/* <Slider {...atnsettings}>
                        {viewProduct.filter((d) => d.future_active == 0).length ? (
                            viewProduct
                                .filter((d) => d.future_active == 0)
                                .map((data, index) => (
                                    <div key={index} className="pr-sm-3">
                                        <AuctionCard
                                            data={data}
                                            favId={`searchProd_${index}`}
                                            drawerHandler={toggleDrawer('right', true, data)}
                                        />
                                        <ListView
                                            data={data}
                                            favId={`searchProd_${index}`}
                                            drawerHandler={toggleDrawer('right', true, data)}
                                            displayActionPanel={true}
                                            removeRightBorder={true}
                                            isOnHomePage={true}
                                        />
                                    </div>
                                ))
                        ) : (
                            <NoRecordsFound />
                        )}
                    </Slider> */}
                    {/* Live Auction */}
                    {/* <TabPanel value={value} index={0}>
                        
                    {/* </TabPanel> */}

                    {/* Upcoming Auction */}
                    {/* <TabPanel value={value} index={1}>
                        {viewProduct.filter((d) => d.future_active == 1).length ? (
                            viewProduct
                                .filter((d) => d.future_active == 1)
                                .map((data, index) => (
                                    <>
                                        <ListView
                                            data={data}
                                            favId={`searchProd_${index}`}
                                            drawerHandler={toggleDrawer('right', true, data)}
                                        />
                                    </>
                                ))
                        ) : (
                            <NoRecordsFound />
                        )}
                    </TabPanel> */}
                </div>
            </section>
            <section className="browseWine">
                <div className="customContainer">
                    {/* <h2 className="homeTitle">Browse Wines</h2> */}
                    <div className="homeCardCnt">
                        {/* 230 - United States */}
                        {/* 110 - Italy */}
                        {/* 75 - France */}
                        <Button
                            className="brwsMrBtn"
                            onClick={() => {
                                handleCountryButtonClick(['75'])
                            }}
                            id="option_france"
                        >
                            <div className="locCard">
                                <img
                                    src={`${
                                        allConfigurationVariables.home_france_image
                                            ? `${global.site_url}/uploads/config/${allConfigurationVariables.home_france_image}`
                                            : `/assets/svg/home_page_images/France.svg`
                                    }`}
                                />
                                <h3>France</h3>
                            </div>
                        </Button>
                        <Button
                            className="brwsMrBtn"
                            onClick={() => {
                                handleCountryButtonClick(['110'])
                            }}
                            id="option_italy"
                        >
                            <div className="locCard">
                                <img
                                    src={`${
                                        allConfigurationVariables.home_italy_image
                                            ? `${global.site_url}/uploads/config/${allConfigurationVariables.home_italy_image}`
                                            : `/assets/svg/home_page_images/Italy.svg`
                                    }`}
                                />
                                <h3>Italy</h3>
                            </div>
                        </Button>

                        <Button
                            className="brwsMrBtn"
                            onClick={() => {
                                handleCountryButtonClick(['230'])
                            }}
                            id="option_us"
                        >
                            <div className="locCard">
                                <img
                                    src={`${
                                        allConfigurationVariables.home_united_image
                                            ? `${global.site_url}/uploads/config/${allConfigurationVariables.home_united_image}`
                                            : `/assets/svg/home_page_images/UnitedStates.svg`
                                    }`}
                                />
                                <h3>United States</h3>
                            </div>
                        </Button>
                        <Button
                            className="brwsMrBtn"
                            onClick={() => {
                                handleCountryButtonClick(otherCountries)
                            }}
                            id="option_othercountries"
                        >
                            <div className="locCard">
                                <img
                                    src={`${
                                        allConfigurationVariables.home_other_image
                                            ? `${global.site_url}/uploads/config/${allConfigurationVariables.home_other_image}`
                                            : `/assets/svg/home_page_images/UnitedStates.svg`
                                    }`}
                                />
                                <h3>Other Countries</h3>
                            </div>
                        </Button>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Home
